import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";

import { ZONE_COLOURS, ZONE_LABELS } from "../helpers/const";
import { type ZoneLabel } from "../types/graphql";

/**
 * Types
 */
interface Props {
  zone?: ZoneLabel | null;
}

/**
 * A member's colour zone — the three-hour UTC band she's usually around in.
 * Worked out from when she attends conversations, else when she logs in, else
 * where her evening falls.
 */
const ZoneChip: React.FC<Props> = ({ zone }: Props) => {
  if (!zone) {
    return (
      <Typography variant="body2" color="textSecondary">
        —
      </Typography>
    );
  }

  return (
    <Tooltip title={ZONE_LABELS.get(zone) ?? zone}>
      <Box display="inline-flex" alignItems="center" gap={0.75}>
        <Box
          component="span"
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: ZONE_COLOURS.get(zone),
            flex: "none",
          }}
        />
        <Typography variant="body2" fontWeight={600}>
          {zone}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default ZoneChip;
